<template>
  <v-row justify="space-between" align="center" class="px-13 top-nav-wrapper">
  <v-col cols="12" class="py-1 px-0"></v-col>
    <v-col cols="10" class="d-flex justify-center items-center py-1 px-0">
      <bs-logo />
    </v-col>
    <v-col cols="2" class="py-1 px-0">
      <global-account-selector v-if="getUserRole !== 'bookingChannelAdmin'" />
<!--      <corporations-select v-if="getUserRole !== 'bookingChannelAdmin'" />-->
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconLoader } from '@/helpers/iconsLoader';
// import CorporationsSelect from '@/components/corporations/CorporationsSelect.vue';
import GlobalAccountSelector from "@/components/corporations/v2/GlobalAccountSelector.vue";

export default {
  name: 'TopBarHeader',
  components: {
    GlobalAccountSelector,
    ...iconLoader.logo,
    // CorporationsSelect,
  },
  computed: {
    ...mapGetters('users', ['getUserRole']),
  },
};
</script>

<style lang="sass" scoped>
.top-nav-wrapper
  background-color: #ffffff !important
  margin: 0px
</style>
